module.exports = __webpack_public_path__ + "media/images/front/icon_review_yj_r-ee404aa2b583a82aa0e267e5fe8f31c3.png";